import { numberSeparator, roundOff } from "utils";
import { unixToDateTime, DATE_FORMAT } from "utils/date";
import {
  SquareArrowOutUpRightIcon,
  StatusCell,
  TableCellWrapper,
  ViewDetailsLink,
} from "./PlanAndBilling/PlanAndBilling.styles";
import { BlueCheckIconV2 } from "assets/icons/index";
import { Text } from "style/v2/components/Typography";

export const billingHistoryColumns = (handleOpenInvoice) => [
  {
    dataField: "created",
    text: "Invoice",
    props: {
      cell: ({ getValue, row }) => {
        const value = getValue();
        const invoiceNumber = row?.original?.number;
        return (
          <Text variant="bodyMedium" as="span">{`Invoice#${
            invoiceNumber || "-"
          } - ${unixToDateTime(value, DATE_FORMAT)}`}</Text>
        );
      },
    },
  },
  {
    dataField: "created",
    text: "Billing date",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return (
          <TableCellWrapper>
            {unixToDateTime(value, DATE_FORMAT)}
          </TableCellWrapper>
        );
      },
    },
  },
  {
    dataField: "total",
    text: "Charge",
    props: {
      cell: ({ getValue }) => {
        const value = getValue() / 100;
        const formattedValue = numberSeparator(roundOff(value));

        return (
          <TableCellWrapper>USD ${formattedValue || "0"}</TableCellWrapper>
        );
      },
    },
  },
  {
    dataField: "status",
    text: "Status",
    props: {
      cell: ({ getValue }) => {
        const status = getValue()?.toLowerCase() || "-";
        return <StatusCell status={status}>{status.toUpperCase()}</StatusCell>;
      },
    },
  },
  {
    dataField: "subscription_details",
    text: "Plan",
    props: {
      cell: ({ getValue }) => {
        const { metadata } = getValue();
        return (
          <TableCellWrapper>{metadata?.product_name || "-"}</TableCellWrapper>
        );
      },
    },
  },
  {
    dataField: "hosted_invoice_url",
    text: "View details",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return (
          <ViewDetailsLink onClick={() => handleOpenInvoice(value)}>
            <SquareArrowOutUpRightIcon />
          </ViewDetailsLink>
        );
      },
    },
  },
];

export const surmountFeatureColumns = [
  {
    dataField: "feature",
    text: "Surmount features",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span>{value}</span>;
      },
    },
  },
  {
    dataField: "free",
    text: "Free",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span>{value ? <BlueCheckIconV2 /> : ""}</span>;
      },
    },
  },
  {
    dataField: "core",
    text: "Surmount Core",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span>{value ? <BlueCheckIconV2 /> : ""}</span>;
      },
    },
  },
  {
    dataField: "plus",
    text: "Surmount Plus",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span>{value ? <BlueCheckIconV2 /> : ""}</span>;
      },
    },
  },
  {
    dataField: "pro",
    text: "Surmount Pro",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span>{value ? <BlueCheckIconV2 /> : ""}</span>;
      },
    },
  },
];
